import { useEffect } from "react";
import { IGif } from "services/types";
import { boostHistory } from "utils/boostHistory";

interface IUseBoostedHostory {
  gif: IGif;
  isVisible: boolean;
}

export const useBoostedHistory = ({
  gif,
  isVisible
}: IUseBoostedHostory) => {
  useEffect(() => {
    if (isVisible && gif.cta) {
      boostHistory.add(gif.id, gif.cta.frequency);
    }
  }, [isVisible, gif]);
};

